<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonApprovalFormStyles contractDetails">
            <van-nav-bar
                title="合同详情"
                left-text="合同列表"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <van-tabs
                    class="vanTabsNav"
                    v-model="active"
                    @click="onTabClick"
                >
                    <van-tab title="基本信息">
                        <div class="BasicContractInfo">
                            <!-- <dl class="infoBg"> -->
                            <!-- <dt class="contractNumber">
                                    合同编号：{{ detail.contract_number }}
                                </dt> -->
                            <div class="infoList">
                                <h4 class="contractNumber">
                                    合同编号：{{ detail.contract_number }}
                                </h4>
                                <van-cell
                                    :value="detail.signing_date"
                                    title="登记时间"
                                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.engineering_name"
                                    title="工程名称"
                                    :icon="require('@/assets/images/icons/icon_2.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.engineering_type_name"
                                    title="工程类型"
                                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.engineering_location"
                                    title="工程地址"
                                    is-link
                                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                                    @click="mapClick"
                                ></van-cell>
                                <van-cell
                                    :value="detail.client_name"
                                    title="客户名称"
                                    :icon="require('@/assets/images/icons/icon_3.png')"
                                    @click="openCustomerInfo"
                                ></van-cell>
                                <van-cell
                                    :value="detail.client_contact_name"
                                    title="客户联系人"
                                    :icon="require('@/assets/images/icons/icon_3.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.client_contact_phone"
                                    title="客户联系人电话"
                                    :icon="require('@/assets/images/icons/icon_4.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.area_name"
                                    title="销售区域(部门)"
                                    :icon="require('@/assets/images/icons/icon_21.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.supply_site_name"
                                    title="供货站点"
                                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.projected_capacity"
                                    title="预计方量"
                                    :icon="require('@/assets/images/icons/icon_30.png')"
                                ></van-cell>
                                <van-cell
                                    :value="detail.predicted_startwork_time"
                                    title="预计开工时间"
                                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                                ></van-cell>
                            </div>
                            <!-- </dl> -->
                        </div>
                    </van-tab>
                    <van-tab title="合同信息表">
                        <div class="contract-msg_list">
                            <ul>
                                <li
                                    v-for="(item,index) in sceneListData"
                                    :key="index"
                                    @click="handClick(item)"
                                >
                                    <span class="iconfont iconhetong"></span>
                                    <p>{{ item.FormName }}</p>
                                    <span class="iconfont iconfanhui1"></span>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="附件资料">
                        <div class="appendix_list">
                            <ul>
                                <li v-for="(item,index) in filegroupinstanceListData" :key="index" @click="attachmentPreview(item)">
                                    <span class="iconfont" :class="addClassName(item)"></span>
                                    <div>
                                        <p>{{ item.FileName }}</p>
                                        <p>
                                            <em>{{ item.CreateDate || '暂无日期' }}</em>
                                            <!-- <em v-if="item.FileType !== '1'">
                                                {{ item.FileSize > 1024 && (item.FileSize/1024).toFixed(2) || item.FileSize }}
                                                {{ (item.FileSize > 1024) ? 'M' : 'k' }}
                                            </em> -->
                                            <em v-if="item.FileType !== '1'">
                                                <template v-if="item.FileSize > 1048576">
                                                    {{ (item.FileSize/1048576).toFixed(2) }}M
                                                </template>
                                                <template v-else-if="item.FileSize < 1048576 && item.FileSize > 1024">
                                                    {{ (item.FileSize/1024).toFixed(2) }}k
                                                </template>
                                                <template v-else>
                                                    {{ item.FileSize }}b
                                                </template>
                                            </em>
                                        </p>
                                    </div>
                                    <span class="iconfont iconfanhui1"></span>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="审批进度">
                        <div class="flowChartList">
                            <template v-for="(item,index) in historyRecordList">
                                <div class="procedureList" :class="{'countersignatureNode': item.node_type ==3}" :key="index">
                                    <h3 class="countersignatureTitle" v-if="item.node_type ==3">
                                        <i class="iconfont icon05qunzufill"></i>
                                        会签审核
                                    </h3>
                                    <template v-for="(k, i) in item.data">
                                        <div class="listBox" :key="i">
                                            <h4>{{ k.Content }}</h4>
                                            <div class="userInfo">
                                                <span class="headPortrait">
                                                    <img src="../contractApproval/images/head_portrait2.png" alt="头像">
                                                    <i class="icon"></i>
                                                </span>
                                                <div>
                                                    <div class="stateBox">
                                                        <span class="name">{{ k.ApproverName }}</span>
                                                        <span class="state">（{{ k.ParticipantAction }}）</span>
                                                    </div>
                                                    <span class="time">{{ k.EndTime }}</span>
                                                </div>
                                            </div>
                                            <ul>
                                                <template v-for="(z, j) in k.CommentList">
                                                    <li :key="j">
                                                        {{ z.Content }}
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同详情
    name: 'contract-details',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === this.backUrl) {
            this.$store.commit('noKeepAlive', 'contract-details');
        }
        next();
    },
    filters: {
        FileName(item) {
            if (/png/i.test(item.FileImage)) {
                return item.FileName + '.png';
            } if (/pdf/i.test(item.FileImage)) {
                return item.FileName + '.pdf';
            } if (/docx/i.test(item.FileImage)) {
                return item.FileName + '.docx';
            } if (/xls/i.test(item.FileImage)) {
                return item.FileName + '.xls';
            } if (/ppt/i.test(item.FileImage)) {
                return item.FileName + '.ppt';
            }
            return '';
        },
    },
    data() {
        return {
            active: this.$route.params.active || 0,
            detail: this.$route.params.obj,
            sceneListData: [],
            filegroupinstanceListData: [],
            url: '',
            historyRecordList: [], // 审批流程记录
            backUrl: '/contractInfo',
        };
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.params.backUrl) {
            this.backUrl = this.$route.params.backUrl;
        }
    },
    activated() {},
    mounted() {
        if (this.active === 1) {
            this.sceneList();
        } else if (this.active === 2) {
            this.filegroupinstanceList();
        }
    },
    destroyed() {

    },
    methods: {
        // 附件预览
        attachmentPreview(data) {
            if (data.FileType !== '1') {
                this.$router.isBack = 2;
                this.getFileDetailFun(data.AFI_Code, 'preview_url');
                setTimeout(() => {
                    this.$router.push({
                        name: 'attachmentView',
                        params: {
                            url: this.url,
                        },
                    });
                }, 300);
            }
        },
        // 获取文件下载预览地址
        getFileDetailFun(id, key) {
            this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${id}/download`;
        },
        mapClick() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'locationInfo', params: {
                address: this.detail.engineering_location,
                longitude: this.detail.x_coordinate_point,
                latitude: this.detail.y_coordinate_point,
            } });
        },
        addClassName(item) {
            let className = '';
            if (item.FileType === '1') {
                className = 'iconfujian';
            } else if (item.FileType === '2') {
                if (/png/i.test(item.FileName)) {
                    className = 'icontupian';
                }
                if (/jpg/i.test(item.FileName)) {
                    className = 'icontupian';
                }
                if (/pdf/i.test(item.FileName)) {
                    className = 'iconpdf1';
                }
                if (/docx/i.test(item.FileName)) {
                    className = 'iconbg-word';
                }
                if (/xlsx/i.test(item.FileName)) {
                    className = 'iconxls';
                }
                if (/ppt/i.test(item.FileName)) {
                    className = 'iconPPT';
                }
                if (/txt/i.test(item.FileName)) {
                    className = 'icontxt';
                }
            }
            return className;
        },
        // 点击tab却换
        onTabClick() {
            if (this.active === 1) {
                this.sceneList();
            } else if (this.active === 2) {
                this.filegroupinstanceList();
            } else if (this.active === 3) {
                this.getApprovalHistory();
            }
        },
        handClick(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'FormView', params: {
                    params: item,
                    detail: this.detail,
                    active: this.active,
                },
            });
        },
        filegroupinstanceList() {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/filegroupinstance/' + this.detail.business_instance_id + '')
                .then(res => {
                    this.filegroupinstanceListData = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        sceneList() {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/scene/' + this.detail.business_instance_id + '/view')
                .then(res => {
                    this.sceneListData = res.BusinessFormList;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取审批记录
        getApprovalHistory() {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/scene/' + this.detail.business_instance_id + '/view')
                .then(res => {
                    this.historyRecordList = res.HistoryNewRecordList;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.backUrl });
        },
        // 打开客户信息
        openCustomerInfo() {
            // this.$router.isBack = 2;
            // this.$router.push({ path: '/customerInfo' });
        },
    },
};
</script>
<style lang="stylus">
.iconfujian
    color #3495FB
.contractDetails
    height 100%
    section
        height calc(100% - 45rpx)
        -webkit-overflow-scrolling: touch;
        overflow: scroll;
        // .msg-wrapper
        //     background-color #F0F0F0
        //     padding-top 10rpx
        //     height 100%
        //     overflow-y: auto
        .contract-msg_list
            ul
                li
                    padding 20px 0
                    border 1px solid rgba(240,240,240,1)
                    display flex
                    line-height 20rpx
                    p
                        font-size 16rpx
                        color #333333
                        flex 1
                    span
                        font-size 16rpx
                        width 50rpx
                        text-align center
                        line-height 20rpx
                        &:first-child
                            font-size 22rpx
                            color #5588F1
                        &:last-child
                            font-size 14rpx
                            color #979EA7
        .appendix_list
            ul
                li
                    padding 10px 0
                    border 1px solid rgba(240,240,240,1)
                    display flex
                    line-height 50rpx
                    span
                        font-size 16rpx
                        width 50rpx
                        text-align center
                        height 50rpx
                        line-height 50rpx
                        &:first-child
                            font-size 22rpx
                        &:last-child
                            font-size 14rpx
                            color #979EA7
                        &.icontupian::before
                            color rgba(133, 115, 226,1)
                        &.iconpdf1::before
                            color rgba(255, 85, 98,1)
                        &.iconbg-word::before
                            color rgba(84, 141, 254,1)
                        &.iconxls::before
                            color rgba(72, 203, 129,1)
                        &.iconPPT::before
                            color rgba(255, 147, 51,1)
                        &.icontxt::before
                            color #f60
                    // p
                    //     font-size 16rpx
                    //     color #333333
                    //     flex 1
                    div
                        flex 1
                        p
                            font-size 16rpx
                            color #000
                            line-height 24rpx
                            &:last-child
                                display flex
                                justify-content space-between
                                font-size 14rpx
                                em
                                    font-size 14rpx
                                    color #979EA7

        .flowChartList
            width 100%
            height 100%
            overflow hidden
            overflow-y auto
            padding 20rpx
            .procedureList
                position relative
                padding-bottom 25rpx
                &:last-child
                    &:before
                        display: none
                &:before
                    content ''
                    width 1px
                    height 100%
                    background: url(../contractApproval/images/up.png) repeat-y
                    position absolute
                    top 12rpx
                    left 20rpx
                &.countersignatureNode
                    &:after
                        content ''
                        width 1px
                        height calc(100% - 95rpx)
                        background: url(../contractApproval/images/up.png) repeat-y
                        position absolute
                        top 11rpx
                        left 50rpx
                    .countersignatureTitle
                        display: flex
                        position: relative
                        z-index 9
                        color #FA6400
                        font-size: 16rpx
                        line-height: 24rpx
                        padding-left: 10rpx
                        margin-bottom: 20rpx
                        &:before
                            content ''
                            width 10rpx
                            height 1px
                            background: url(../contractApproval/images/across.png) repeat-x
                            position absolute
                            top 10rpx
                            left 41rpx
                        i
                            width 24rpx
                            height 24rpx
                            background: #FA6400
                            color #fff
                            text-align: center
                            line-height: 24rpx
                            font-size: 16rpx
                            border-radius: 50%
                            margin-right: 20rpx
                    .listBox
                        padding-left: 70rpx
                        position: relative
                        h4
                            color #FA6400
                            position: relative
                            &:before
                                content ''
                                width 35rpx
                                height 1px
                                background: url(../contractApproval/images/across.png) repeat-x
                                position absolute
                                top 8rpx
                                left -35rpx
                .listBox
                    h4
                        font-size 18rpx
                        line-height 18rpx
                        color #0285FE
                        padding-left 35rpx
                        background url('../contractApproval/images/decorate.png') no-repeat
                        background-size 12rpx 12rpx
                        background-position left center
                        margin-bottom: 10rpx
                        margin-left: 15rpx
                        display: flex
                        position: relative
                        z-index 9
                    .userInfo
                        overflow hidden
                        display flex
                        span
                            display: inline-block
                            font-size 16rpx
                            line-height 20rpx
                            &.headPortrait
                                width 40rpx
                                height 40rpx
                                position relative
                                img
                                    width 40rpx
                                    height 40rpx
                                i
                                    position absolute
                                    bottom 0
                                    right 0
                                    width 15rpx
                                    height 15rpx
                                    background url('../contractApproval/images/pass.png') no-repeat
                                    background-size 15rpx 15rpx
                            &.name
                                color #333333
                                margin-left 15rpx
                            &.state
                                color #2BC671
                            &.time
                                margin-left 15rpx
                                color #979EA7
                                font-size: 13rpx
                        div
                            width 100%
                        .stateBox
                            display flex
                            justify-content space-between
                    ul
                        margin-left: 55rpx
                        li
                            padding: 14rpx 0
                            border-bottom: 1px solid #D7D7D7
                            font-size: 14rpx
                            line-height: 20rpx
                            color #4A4A4A
                            margin-bottom: 10rpx
                            &:last-child
                                border-bottom none
</style>
